import tw from "twin.macro";

const Base = tw.div`bg-white shadow-lg p-6 rounded flex flex-col`;
const LogoContainer = tw.a`block h-32 flex items-center justify-around`;
const Logo = tw.img`h-24 mx-auto inline-block`;
const Body = tw.div`mt-4`;
const Paragraph = tw.p`mb-4`;
const Pi = tw.div``;
const PiHeadingBase = tw.h3`pt-4 font-bold mb-4`;
const PiBody = tw.p``;

export default {
  Base,
  LogoContainer,
  Logo,
  Body,
  Paragraph,
  Pi,
  PiHeadingBase,
  PiBody,
};
